import { PropsWithChildren, ReactElement, ReactNode } from 'react';

import styles from './Modal.module.scss';
import ModalContentWrapper from './ModalContentWrapper';
import ModalOverlay from './ModalOverlay';

interface IModalProps {
  onClose: () => void;
  title: string;
  modalIcon?: ReactNode;
  description: string | ReactNode | ReactElement;
  actionElement: ReactNode | ReactElement;
}

const Modal = ({
  onClose,
  modalIcon,
  title,
  actionElement,
  description,
}: PropsWithChildren<IModalProps>) => {
  return (
    <ModalOverlay onClose={onClose}>
      <ModalContentWrapper
        wrapperClassName={styles.commonModalContentWrapper}
        onClose={onClose}
        modalIcon={modalIcon}
      >
        <div className={styles.contentBody}>
          <h5 className={styles.modalTitle}>{title}</h5>
          <div className={styles.modalDescription}>{description}</div>
        </div>
        {actionElement}
      </ModalContentWrapper>
    </ModalOverlay>
  );
};

export default Modal;
